import React from "react";
import { Link } from "react-router-dom";

import "./Button.css";

const Button = ({
	href,
	to,
	size,
	inverse,
	danger,
	className,
	children,
	exact,
	...rest
}) => {
	const classes = [
		"button",
		`button--${size || "default"}`,
		inverse && "button--inverse",
		danger && "button--danger",
		className,
	]
		.filter(Boolean)
		.join(" ");

	if (href) {
		return (
			<a className={classes} href={href} {...rest}>
				{children}
			</a>
		);
	}

	if (to) {
		return (
			<Link className={classes} to={to} exact={exact} {...rest}>
				{children}
			</Link>
		);
	}

	return (
		<button className={classes} {...rest}>
			{children}
		</button>
	);
};

export default Button;
